class SliderBannerCustom {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.slider-banner-custom__track');
    this.slides = Array.from(section.querySelectorAll('.slider-banner-custom__slide'));
    this.dots = Array.from(section.querySelectorAll('.slider-banner-custom__dot'));
    this.autoplay = section.dataset.autoplay === 'true';
    this.autoplaySpeed = Number(section.dataset.autoplaySpeed) || 4000;
    this.transitionSpeed = Number(section.dataset.transitionSpeed) || 800;
    this.index = 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchEndX = 0;

    if (!this.track || this.slides.length < 2) return;

    this.track.style.transition = `transform ${this.transitionSpeed}ms ease`;
    this.bindEvents();
    this.goTo(0, false);
    this.startAutoplay();
  }

  bindEvents() {
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const target = Number(dot.dataset.slideTo);
        this.goTo(target);
        this.restartAutoplay();
      });
    });

    this.section.addEventListener('mouseenter', () => this.stopAutoplay());
    this.section.addEventListener('mouseleave', () => this.startAutoplay());
    this.section.addEventListener('focusin', () => this.stopAutoplay());
    this.section.addEventListener('focusout', () => this.startAutoplay());

    this.section.addEventListener('touchstart', (event) => {
      this.touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    this.section.addEventListener('touchend', (event) => {
      this.touchEndX = event.changedTouches[0].clientX;
      this.handleSwipe();
    }, { passive: true });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  handleSwipe() {
    const delta = this.touchStartX - this.touchEndX;
    if (Math.abs(delta) < 40) return;

    if (delta > 0) {
      this.next();
    } else {
      this.prev();
    }
    this.restartAutoplay();
  }

  next() {
    const nextIndex = (this.index + 1) % this.slides.length;
    this.goTo(nextIndex);
  }

  prev() {
    const prevIndex = (this.index - 1 + this.slides.length) % this.slides.length;
    this.goTo(prevIndex);
  }

  goTo(index, animate = true) {
    this.index = index;
    if (!animate) {
      this.track.style.transition = 'none';
    }

    this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;

    if (!animate) {
      requestAnimationFrame(() => {
        this.track.style.transition = `transform ${this.transitionSpeed}ms ease`;
      });
    }

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    this.stopAutoplay();
    this.timer = window.setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

function initSliderBannerCustom() {
  const sections = document.querySelectorAll('.slider-banner-custom');
  sections.forEach((section) => {
    if (section.dataset.sliderInitialized === 'true') return;
    section.dataset.sliderInitialized = 'true';
    new SliderBannerCustom(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSliderBannerCustom);
} else {
  initSliderBannerCustom();
}

document.addEventListener('shopify:section:load', initSliderBannerCustom);
